<i18n
  src="@/locales/views/producer/reporting/process/list_processes.yml"
  lang="yaml"
></i18n>
<template>
  <div class="mt-8 mb-8">
    <h1 class="page-title">{{ module_name }}</h1>
  </div>

  <div
    v-if="load_data_general"
    class="bg-white shadow overflow-hidden sm:rounded-md"
  >
    <ul role="list" class="divide-y divide-gray-200">
      <li
        v-for="agro_exporter_process in agro_exporter_processes"
        :key="agro_exporter_process.id"
      >
        <div
          class="block hover:bg-gray-50 cursor-pointer"
          @click.prevent="goToShowReports(agro_exporter_process)"
        >
          <div class="px-4 py-4 sm:px-6">
            <div class="flex items-center justify-between">
              <p class="text-sm font-medium text-gray-900 truncate">
                {{ agro_exporter_process.name }} -
                {{ agro_exporter_process.agro_exporter.name }}
              </p>
              <div class="ml-2 flex-shrink-0 flex">
                <a class="link invisible sm:visible">
                  <i class="fa-solid fa-eye"></i>
                  <span class="space-icon"></span>{{ $t("labels.show_link") }}
                </a>
              </div>
            </div>
            <div class="mt-2 sm:flex sm:justify-between">
              <!-- <div class="sm:flex space-x-4">
                <p class="flex items-center text-sm text-gray-500">
                  <i class="fa-solid fa-apple-crate flex-shrink-0" aria-hidden="true" />
                  <span class="space-icon"></span>
                  {{ agro_exporter_process.total }} Kg
                </p>

                <p class="flex items-center text-sm text-gray-500">
                  <i class="fa-solid fa-box-check flex-shrink-0" aria-hidden="true" />
                  <span class="space-icon"></span>
                  {{ agro_exporter_process.ok }} Kg
                </p>
                <p class="flex items-center text-sm text-gray-500">
                  <i class="fa-solid fa-xmark flex-shrink-0" aria-hidden="true" />
                  <span class="space-icon"></span>
                  {{ agro_exporter_process.discard }} Kg
                </p>
              </div> -->
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
  <loading-message v-else />
</template>

<script>
import Requester from "@/views/producer/requesters/reporting/process/list_processes.js";

export default {
  name: "PRODReportingProcessListProcesses",
  props: { producer_id: { required: true } },
  data() {
    return {
      load_data_general: true,
      agro_exporter_processes: []
    };
  },
  methods: {
    fetchAgroExporterProcesses: async function () {
      let response = await Requester.fetchAgroExporterProcesses(
        this.producer_id
      );
      this.agro_exporter_processes = response.data;
      this.load_data_general = true;
    },
    goToShowReports: function (agro_exporter_process) {
      this.$router.push({
        name: this.routeName("show_reports"),
        params: {
          producer_id: this.producer_id,
          agro_exporter_process_id: agro_exporter_process.id
        }
      });
    }
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          producer_id: this.producer_id
        }
      }).then(() => this.fetchAgroExporterProcesses())
    );
  }
};
</script>
